import { makeAutoObservable, runInAction } from "mobx";
import { Friend } from "../models/Friend";
import { agent } from "../api/agent";

export default class FriendStore {
    searchResults: Friend[] = [];
    searchTerm: string = "";
    searching: boolean = false;
    
    constructor() {
        makeAutoObservable(this);
    }

    setSearchTerm = (term: string) => {
        this.searchTerm = term;
    }

    searchFriends = async (searchTerm: string) => {
        if (!searchTerm || searchTerm.length < 3) {
            runInAction(() => {
                this.searchResults = [];
            });
            return;
        }

        this.searching = true;
        try {
            const results = await agent.Friends.search(searchTerm);
            runInAction(() => {
                this.searchResults = results;
                this.searching = false;
            });
        } catch (error) {
            console.log(error);
            runInAction(() => {
                this.searching = false;
            });
        }
    }
    

    clearSearch = () => {
        this.searchResults = [];
        this.searchTerm = "";
    }

    // Update following status in search results
    updateFollowingInSearchResults = (friendId: string) => {
        const friend = this.searchResults.find(f => f.id === friendId);
        if (friend) {
            friend.following = !friend.following;
        }
    }
}